import api from 'services/api';
import { getCompanyContext } from 'utils/setCompanyContext';

class ComercialComissaoService {
  constructor() {
    this.baseURL = '';
  }

  getEmpresaPadrao() {
    const ctx = getCompanyContext();
    return ctx?.companies?.[0]?.name || 'MOV Fibra';
  }

  getDataInicioMes() {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().split('T')[0];
  }

  getDataFimMes() {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().split('T')[0];
  }

  async buscarDadosComissao(params = {}) {
    try {
      const response = await api.post(`${this.baseURL}/n8n/comercial/comissao`, {
        empresa: params.empresa || this.getEmpresaPadrao(),
        data_inicio: params.data_inicio || this.getDataInicioMes(),
        data_fim: params.data_fim || this.getDataFimMes(),
        vendedor: params.vendedor || '',
        colaborador: params.colaborador || '',
        cidade: params.cidade || '',
        eh_loja: !!params.eh_loja,
        _force: !!params._force,
      });

      return {
        success: true,
        data: response.data?.data ?? response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Erro ao buscar dados de comissão',
        data: null,
      };
    }
  }
}

const comercialComissaoService = new ComercialComissaoService();
export default comercialComissaoService;
